/*
 * @Description: 请求的封装 基于接入层 V3 协议
   http://ovbgame.woa.com/game-docs/yybgame/protocol.html
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-22 11:13:15
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2022-07-01 17:20:32
 */

import { setCookie } from '@tencent/halo-util';
import { eventBus, getLoginCgiHost, getMailCgiHost, isAppMarket } from '@tencent/syzs-login-sdk-utils';
import { Toast } from '../component';
import i18n from '../i18n';
import { ICheckUserInfo, ICheckUserInfoData, ILoginType, IUserInfo } from '../types';
import { clearCookie, postMessageToParent } from './util';


export enum IDoLoginCode {
  'LOGIN_SUCCESS' = 0,
  'USER_NOT_REGISTER' = 20002,
}

export const TOKEN_AND_USER_INFO_KEY = 'TOKEN_AND_USER_INFO';
const COOKIE_DOMAIN = ['qq.com', 'gameloop.com'];

const COOKIE_KEY = [
  'accesstoken',
  'openid',
  'logintype',
  'user_id',
  'refreshtoken',
  'register_country_code'];

const defaultBusinessId = 'gameloop_login';


// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LoginRequest {
  public static async request(url: string, data: Record<string, any>, businessId?: string) {
    try {
      const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          'Ual-Access-Businessid': businessId || defaultBusinessId,
          'Ual-Access-Timestamp': `${Date.now()}`,
          'Ual-Access-Nonce': `${Math.floor(Math.random() * 100)}`,
        },
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      });


      if (!response) throw new Error(`request timeout ${url}`);

      return await response.json();
    } catch (e: any) {
      window.aegis.report('aegisError', `request Error: url ${url} ual-access-ret ${e.response?.headers['ual-access-ret']} trpc-error-msg ${e.response?.headers['trpc-error-msg']} e ${JSON.stringify(e)}`);

      return {};
    }
  }

  public static async code2AccessToken(code: string, loginType: ILoginType) {
    const code2token = await this.request(`${getLoginCgiHost()}/v3/login`, {
      token_info: {
        code,
      },
      userinfo: {
        login_type: loginType,
      },
    });

    if (!code2token) {
      window.aegis.error(`Log In Failed code2token ${code2token}`);

      return;
    }

    const { status_code, data, msg } = code2token as ICheckUserInfo;

    switch (status_code) {
      case IDoLoginCode.LOGIN_SUCCESS: {
        const userInfoTemp = data;

        this.setLoginInfolocalStorage(userInfoTemp);
        this.setLoginCookie();

        const mail = await this.getUserBindEmail();
        if (mail) {
          userInfoTemp.userinfo.userBindMail = mail;

          this.setLoginInfolocalStorage(userInfoTemp);
        }

        await postMessageToParent('LOGIN_SUCCESS', {
          userInfo: this.getUserInfoAdapter(),
          rawInfo: userInfoTemp,
        });

        window.report(`syzs_login_v2_login_success_${loginType}`);

        window.close();
      }

        break;
      case IDoLoginCode.USER_NOT_REGISTER:
        this.setLoginInfolocalStorage(data);
        window.report(`syzs_login_v2_login_user_not_register_${loginType}`);

        if (isAppMarket()) {
          location.hash = '/RegisterMain';
        } else {
          await postMessageToParent('USER_NOT_REGISTER', loginType);
          window.close();
        }

        break;
      default:
        window.report(`syzs_login_v2_login_failed_${loginType}`);

        Toast.error(i18n.l('LogFailed'));
        window.aegis.error(`Log In Failed status_code ${status_code} msg ${msg}`);

        setTimeout(() => {
          if (isAppMarket()) {
            location.href = `${location.origin + location.pathname}#/Login`;
          } else {
            window.close();
          }
        }, 2000);

        break;
    }

    return code2token;
  }


  /**
   * 写入 Cookie
   * @returns void
   */
  public static setLoginCookie() {
    const userInfoTemp = this.getLoginInfolocalStorage();

    if (!userInfoTemp) return;
    const { token_info, userinfo } = userInfoTemp;
    const { access_token, refresh_token } = token_info;
    const { open_id, login_type, user_id, register_country_code } = userinfo;

    COOKIE_DOMAIN.forEach((domain) => {
      setCookie('accesstoken', access_token, domain, '/', 365);
      setCookie('openid', open_id, domain, '/', 365);
      setCookie('logintype', login_type, domain, '/', 365);
      setCookie('user_id', user_id, domain, '/', 365);
      refresh_token && setCookie('refreshtoken', refresh_token, domain, '/', 365);
      setCookie('register_country_code', register_country_code, domain, '/', 365);
    });
  }

  /**
   * 写入 localStorage
   * @returns void
   */

  public static setLoginInfolocalStorage(userInfoTemp: ICheckUserInfoData) {
    if (!userInfoTemp) return;
    const { token_info, userinfo } = userInfoTemp;

    localStorage.setItem(TOKEN_AND_USER_INFO_KEY, JSON.stringify({ token_info, userinfo }));
  }

  /**
   * 读出 用户信息
   */

  public static getLoginInfolocalStorage() {
    const userinfostr = localStorage.getItem(TOKEN_AND_USER_INFO_KEY);

    try {
      if (userinfostr) {
        const userinfoByStorge: ICheckUserInfoData = JSON.parse(userinfostr);

        return userinfoByStorge;
      }
    } catch (e) {
      window.aegis.error(`getLoginInfolocalStorage Error ${e}`);

      return null;
    }

    return null;
  }

  /**
   * 清除 Cookie
   * @returns void
   */
  public static clearLoginCookie = async () => {
    const userInfoTemp = this.getLoginInfolocalStorage();

    if (!userInfoTemp) {
      await postMessageToParent('LOGOUT_SUCCESS', {
        userInfo: null,
      });

      return;
    }

    COOKIE_KEY.forEach((item) => {
      COOKIE_DOMAIN.forEach((domain) => {
        clearCookie(item, domain, '/');
      });
    });

    const { userinfo, token_info } = userInfoTemp;

    const result = await this.request(`${getLoginCgiHost()}/v3/signout`, {
      token_info,
      userinfo: {
        user_id: userinfo.user_id,
        open_id: userinfo.open_id,
        login_type: userinfo.login_type,
        register_country_code: +userinfo.register_country_code,
      },
    });

    const { status_code, msg } = result;

    if (status_code !== 0) {
      window.aegis.report(`signout Fail status_code ${status_code} msg ${msg} register_country_code ${userinfo.register_country_code}`);
    }

    eventBus.emit('clearLoginState', userinfo.login_type);

    localStorage.removeItem(TOKEN_AND_USER_INFO_KEY);

    await postMessageToParent('LOGOUT_SUCCESS', {
      userInfo: null,
    });

    return;
  };

  /**
   * 取得用户信息适配器
   * @returns IUserInfo | null
   */
  public static getUserInfoAdapter = (): IUserInfo | null => {
    const userInfoTemp = this.getLoginInfolocalStorage();

    if (userInfoTemp) {
      const { token_info, userinfo } = userInfoTemp;
      const { access_token } = token_info;
      const {
        open_id,
        register_country_code,
        email,
        name,
        picture_url,
        login_type,
        register_country_name,
        userBindMail,
        area,
        user_id,
      } = userinfo;

      return {
        accountMail: email,
        username: name,
        profilePhoto: picture_url,
        userBindMail,
        loginType: login_type,
        accountRegionName: register_country_name,
        accountRegionId: register_country_code,
        openId: open_id,
        accessToken: access_token,
        nickname: name,
        area,
        userId: user_id,
      };
    }

    return null;
  };

  /**
   * 取得用户绑定邮箱
   * @returns IUserInfo | null
   */
  public static async getUserBindEmail() {
    const result = await this.request(`${getMailCgiHost()}/v3/check_user_has_email`, {}, 'gameloop_store');
    const { code, email } = result;

    if (code === 0) return email;

    return null;
  }
}

